import { CreditCard, UsersRound, NotebookPen, FileImage } from "lucide-react";

import SectionHeading from "../../components/common/SectionHeading";

const features = [
  {
    icon: CreditCard,
    title: "Estimates & Invoices",
    description: "One click to send estimates & invoices to customers"
  },
  {
    icon: UsersRound,
    title: "Customer Management",
    description: "Keep track of all your customers and contacts"
  },
  {
    icon: NotebookPen,
    title: "Project Management",
    description: "Organize your projects easily"
  },
  {
    icon: FileImage,
    title: "Photo Showcase",
    description: "Document works and share with customers"
  }
];

export default function FeaturesSection() {
  return (
    <section className="bg-page-gray-soft section-padding">
      <div className="container-safe">
        <SectionHeading
          title="Free Tools Purposely Designed And Built For Home Improvement And Construction Pros"
          description="No Hidden Fees - No Credit Card Required"
        />
<div>

</div>
        <div className="xs:mt-10 mt-6 grid grid-cols-1 gap-8 md:mt-14 md:grid-cols-2 xl:grid-cols-4">
          {features.map(({ icon: Icon, title, description }) => (
            <article
              key={title}
              className="bg-background shadow-card hover:shadow-card-hover xs:py-11 rounded-2xl px-9 py-14 text-center transition-shadow"
            >
              <div className="bg-primary/10 mx-auto grid size-20 place-items-center rounded-2xl">
                <Icon className="text-primary size-8" />
              </div>
              <h3 className="xs:text-x1.5 xs:leading-7 mt-2 text-lg leading-4 font-medium">
                {title}
              </h3>
              <p className="text-paragraph xs:leading-6 max-xs:text-xs mt-2 leading-4">
                {description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
